import * as React from "react";

import { cn } from "@/lib/utils";
import { EmptyState } from "@/components/ui/empty-state";

/**
 * Phase 10B 2050 ChartCard — same surface treatment as DataCard but
 * reserves a stable min-height so charts don't reflow during load.
 */
const ChartCard = React.forwardRef(
  (
    {
      className,
      title,
      description,
      actions,
      minHeight = 260,
      loading = false,
      empty = false,
      emptyTitle = "No data yet",
      emptyDescription = "Data will appear once it flows through.",
      emptyIcon,
      children,
      bodyClassName,
      ...props
    },
    ref
  ) => {
    const showEmpty = empty && !loading;
    return (
      <div
        ref={ref}
        className={cn("card-2050 overflow-hidden focus-2050", className)}
        {...props}
      >
        {(title || description || actions) && (
          <div className="flex items-start justify-between gap-4 px-6 py-4 border-b border-ink-200/60 dark:border-ink-800/60">
            <div className="min-w-0">
              {title && (
                <div className="text-sm font-semibold tracking-tight truncate">
                  {title}
                </div>
              )}
              {description && (
                <div className="mt-0.5 text-xs text-ink-500">{description}</div>
              )}
            </div>
            {actions && (
              <div className="flex items-center gap-2 flex-shrink-0">
                {actions}
              </div>
            )}
          </div>
        )}
        <div
          className={cn("p-6 flex flex-col", bodyClassName)}
          style={{ minHeight: `${minHeight}px` }}
        >
          {loading ? (
            <div className="flex-1 flex items-center justify-center">
              <div className="h-full w-full min-h-[200px] skeleton" />
            </div>
          ) : showEmpty ? (
            <div className="flex-1 flex items-center justify-center">
              <EmptyState
                title={emptyTitle}
                description={emptyDescription}
                icon={emptyIcon}
              />
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    );
  }
);
ChartCard.displayName = "ChartCard";

export { ChartCard };
